import gsap from 'gsap'
import store from '../util/store'

export class Accordion {
  constructor({ el, header, content, contentPadding }) {
    this.el = el
    this.header = header
    this.content = content
    this.hasTable = content.dataset.table
    this.paddingBottomOnly = Boolean(content.dataset.paddingBottom)
    this.paddingTopOnly = Boolean(content.dataset.paddingTop)
    this.contentPadding = contentPadding
    this.isOpen = false

    this.init()
  }

  _checkVw(value) {
    if (window.innerWidth < 1024) {
      return value + 'px'
    }

    return value * 100 / 1512 + 'vw'
  }

  init() {
    gsap.set(this.header, {
      cursor: 'pointer'
    })

    gsap.set(this.content, {
      paddingTop: 'Ovw',
      paddingBottom: '0vw',
      maxHeight: '0vw',
      overflow: 'hidden'
    })

    if (store.detect.isMobile) {
      this.header.addEventListener('click', () => {
        const target = this.content.querySelector('.dt-table') || this.content
        const height = target.scrollHeight + this.contentPadding * 2

        if (this.isOpen) {
          this.content.style.maxHeight = '0'
          this.content.style.paddingTop = '0'
          this.content.style.paddingBottom = '0'
          this.el.classList.remove('--open')
          this.isOpen = false
        } else {
          this.content.style.maxHeight = height + 'px'
          this.content.style.paddingTop = this.paddingBottomOnly ? '0' : this.contentPadding + 'px'
          this.content.style.paddingBottom = this.paddingTopOnly ? '0' : this.contentPadding + 'px'
          this.el.classList.add('--open')
          this.isOpen = true
        }
      })

      return
    }

    const tl = gsap.timeline({
      duration: 0.3,
      ease: 'power3.out',
      paused: true
    })

    this.header.addEventListener('click', () => {
      if (!this.table && this.content.querySelector('.dt-table')) {
        this.table = this.content.querySelector('.dt-table')

        tl.to(this.content, {
          paddingTop: this.paddingBottomOnly ? '0vw' : this._checkVw(this.contentPadding),
          paddingBottom: this.paddingTopOnly ? '0vw' : this._checkVw(this.contentPadding),
          maxHeight: this._checkVw(this.table.scrollHeight + this.contentPadding * 2)
        })
      } else if (!this.table) {
        tl.to(this.content, {
          paddingTop: this.paddingBottomOnly ? '0vw' : this._checkVw(this.contentPadding),
          paddingBottom: this.paddingTopOnly ? '0vw' : this._checkVw(this.contentPadding),
          maxHeight: this._checkVw(this.content.scrollHeight + this.contentPadding * 2)
        })
      }

      if (this.isOpen) {
        tl.reverse()
        this.el.classList.remove('--open')
        this.isOpen = false
      } else {
        tl.play()
        this.el.classList.add('--open')
        this.isOpen = true
      }
    })
  }
}

export default function createAccordion(config) {
  return new Accordion(config)
}
